<!--
 * @Author: caizexin caizexin@kjgb.net
 * @Date: 2023-02-13 09:16:22
-->
<template>
    <div>
        <a-layout class="layout">
            <a-layout-sider 
                :width="250" 
                class="layout_side" 
                v-model:collapsed="collapsed"
                collapsedWidth="70"
                :collapsible="false"
                @collapse="collapse"
            >
                <div class="logo">
                    <img :src="small_logo" alt="" width="" height="30" v-if="collapsed"/>
                    <img :src="logo" alt="" width="140" height="30" v-if="!collapsed" />
                </div>
                <Menu :isCollapsed="collapsed"></Menu>
                <div class="avatar" v-if="!collapsed">
                    <img :src="avatarUrl" alt="" width="48">
                    <div class="user_email">{{ email }}</div>
                    <a-button type="primary" size="small" style="margin-top: 10px;" @click="logout">
                        {{ $t('login.logout') }}
                    </a-button>
                    <div class="version">{{ $t('base.version') }} {{ appVersion }} </div>
                </div>
                <!-- <div class="avatar2" v-if="collapsed">
                    <img src="@/assets/image/profile.png" alt="" width="48">
                    <div class="user_email"></div>
                    <a-button type="primary" size="small" style="margin-top: 10px;" @click="logout">
                        {{ $t('login.logout') }}
                    </a-button>
                    <a-tooltip>
                        <template #title>{{ $t('login.logout') }}</template>
                        <img src="@/assets/image/logout.png" alt="" width="18" class="logout_icon2" @click="logout">
                    </a-tooltip>
                </div> -->
            </a-layout-sider>
            <a-layout class="layout_right">
                <!-- <a-layout-header class="layout_header">
                    <div class="header_top">
                        <BreadCrumb class="breadCrumb" @collapsMenu="collapsMenu"></BreadCrumb>
                        <Avatar class="avatar"></Avatar>
                    </div>
                </a-layout-header> -->
                <a-layout-content class="layout_content">
                    <Main></Main>
                </a-layout-content>
            </a-layout>
        </a-layout>
    </div>
</template>

<script setup>
    import { onMounted, ref, toRefs } from 'vue';
    import { useRoute, useRouter } from 'vue-router'

    import Menu from './component/Menu.vue';
    import BreadCrumb from './component/BreadCrumb.vue';
    import Avatar from './component/Avatar.vue';
    // import TabBar from './component/TabBar.vue';
    import Main from './component/Main.vue';
    import { CarTwoTone } from '@ant-design/icons-vue';
    import { message, Modal } from 'ant-design-vue';
    import { useI18n } from 'vue-i18n';
    import { LoginApi } from '@/api/LoginApi';
    import avatar from '@/assets/image/profile.png';

    const router = useRouter()
    const route = useRoute()

    const {t} = useI18n()

    // 直接使用注入的全局变量
    const appVersion = __APP_VERSION__;
    const buildTime = __BUILD_TIME__;

    const collapsed = ref(false)
    const userInfo = ref(JSON.parse(sessionStorage.getItem('userInfo')))
    const user_name = ref('')
    const email = ref('')
    const small_logo = ref('')
    const logo = ref('')
    const avatarUrl = ref('')

    const collapse = (val, type)=>{
        collapsed.value = val
    }


    const logout = ()=>{
        Modal.confirm({
            title: t('base.tip'),
            content: t('login.logoutTip'),
            okText: t('base.ok'),
            cancelText: t('base.cancel'),
            onOk:()=>{
                sessionStorage.removeItem('token')
                sessionStorage.removeItem('userInfo')
                sessionStorage.removeItem('logo')
                sessionStorage.removeItem('routerList')
                router.push('/Login')
            },
        });
    }

    const getUserAvatar = async ()=>{
        const res = await LoginApi.getInstance().getUserAvatar(userInfo.value.id)
        return res.data.avatar? res.data.avatar.avatar_url : avatar
    }


    onMounted(async()=>{
        if(userInfo.value){
            user_name.value = userInfo.value.user_name
            email.value = userInfo.value.email
            avatarUrl.value = await getUserAvatar()
        }

        if(sessionStorage.getItem('logo')){
            small_logo.value = JSON.parse(sessionStorage.getItem('logo')).small_logo
            logo.value = JSON.parse(sessionStorage.getItem('logo')).logo
        }
   
    })

</script>
z
<style lang="scss" scoped>
$header-bar-height:200px;
.layout{
    color: #fff;
    .layout_side{
        position: relative;
        margin-top: 95px;
        height: calc(100vh - 95px);
        width: auto;
        border-right: 1px solid #e7ebf0;
        overflow-y:scroll;

        .logo{
            position: fixed;
            top: 0;
            width: 240px;
            height: 95px;
            background: #fff;
            font-size: 20px;
            text-align: center;
            padding: 30px 10px;
            .carTwoTone{
                margin-right: 8px;
            }
        }

        .logoText{
            padding: 5px;
            font-size: 13px;
            border-bottom: 1px solid #666;
        }

        .avatar{
            position: fixed;
            bottom: 0;
            padding: 20px 0 40px;
            width: 240px;
            text-align: center;
            color: #1226AA;
            background: #fff;

            .user_name{
                font-weight: bold;
            }

            .user_email{
                font-weight: 500;
            }

            .logout_icon1{
                margin-top: 10px;
                cursor:pointer;
            }

            .version{
                position: fixed;
                bottom: 10px;
                left: 90px;
                font-size: 10px;
                font-weight: 600;
                color: #333;
            }
        }

        .avatar2{
            position: absolute;
            bottom: 48px;
            padding: 20px 0;
            width: 100%;
            text-align: center;
            color: #1226AA;
            background: #fff;
            

            .logout_icon2{
                margin-top: 50px;
                cursor:pointer;
            }
        }
    }
    
    .layout_right{
        background: #fff;
    }
    .layout_header{
        background: #fff;
        padding: 10px 0;
        height: auto;
        // box-shadow: 0px -2px 21px -15px #333;

        .header_top{
            display: flex;
            justify-content: center;
            align-items: center;
            // border-bottom: 1px solid #f1f1f1;

            .breadCrumb,.avatar{
                display: flex;
                flex: 3;
            }
            .breadCrumb{
                padding-left: 20px;
                align-items: center;
            }
            // .avatar{
            //     flex: 1;
            //     justify-content: end;
            //     padding-right: 20px;
            // }
        }
        .tabBar{
            padding-left: 20px;
        }
    }
    .layout_content{
        // margin: 10px 16px 0; 
        padding: 10px 40px;
        color: #333;
        overflow-y: scroll;
        height: calc(100vh - $header-bar-height);
        background: linear-gradient(-45deg, #f7f6f9 0%, #f7f6f9 60%, #c4dafd 100%);
    }
} 

::v-deep .ant-layout .ant-layout-sider{
    // background: #f7fafc; 
    background: #fff;        
}

::v-deep .ant-layout .ant-layout-sider-trigger{
    background: #f7fafc;  
    color: #333;      
}


::v-deep .ant-menu-submenu-popup .ant-menu-vertical .ant-menu-item,
::v-deep .ant-menu-submenu-popup .ant-menu-vertical .ant-menu-submenu-title{
    color: #333 !important;      
}
</style>